import React from 'react';
import EquipmentSection from './EquipmentSection';
import EquipmentCatalog from './EquipmentCatalog';
import { useEquipmentLabels } from '../hooks/useEquipment';

export default function EquipmentOptions({ options, catalog }) {
  const label = useEquipmentLabels();
  if (!options.items.length && !catalog) return null;
  return <EquipmentSection eyebrow={label('optionsLabel')} title={options.title}>
    <div className="equipment-options">
      {options.items.map((option, index) => <article key={option.id}>
        <span className="equipment-option-number">{String(index + 1).padStart(2, '0')}</span>
        {option.image && <img className="equipment-option-image" src={option.image} alt="" loading="lazy" />}
        <h3>{option.title}</h3>
        <p>{option.description}</p>
      </article>)}
    </div>
    <EquipmentCatalog catalog={catalog} />
  </EquipmentSection>;
}
